import { Box, Button, Icon, Section, Text, unit, colors } from '@acast/decibel';
import { PodcastDuotoneGlyph } from '@acast/decibel-glyphs';
import React from 'react';
import navigateTo from 'shared/helpers/navigate-to';

const handleClickNewShow = () => navigateTo('/shows/new');

const FirstTimeOverview = () => {
  return (
    <Section>
      <Box flexDirection="column" alignItems="center" py={14}>
        <Box mb={6} display="inline-flex">
          <Icon glyph={PodcastDuotoneGlyph} size={unit(12)} primaryColor={colors.black32} />
        </Box>
        <Text variant="h4" mb={3}>
          You don't seem to have any shows
        </Text>
        <Text variant="subtitle1" mb={6}>
          You can create a new show by clicking the button below.
        </Text>
        <Button variant="primary" onClick={handleClickNewShow}>
          Create show
        </Button>
      </Box>
    </Section>
  );
};

export default FirstTimeOverview;
